import React, { useEffect, useState } from 'react';
import { Search, X } from 'lucide-react';
import { activitySearchWrapperClass, activitySearchInputClass } from 'features/activity/styles/dataTableStyles';

export default function SemanticSearchBar({
  value,
  onChange,
  placeholder = 'Search runs…',
  debounceMs = 350,
  className = '',
  width = 360,
}) {
  const [local, setLocal] = useState(value || '');

  useEffect(() => setLocal(value || ''), [value]);

  useEffect(() => {
    const id = setTimeout(() => {
      if (local !== value) onChange(local);
    }, debounceMs);
    return () => clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [local]);

  return (
    <div
      className={`${activitySearchWrapperClass} ${className}`}
      style={{ width: '100%', maxWidth: width }}
    >
      <Search size={14} className="flex-none text-[color:var(--text-muted)]" aria-hidden />
      <input
        type="text"
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        placeholder={placeholder}
        className={activitySearchInputClass}
      />
      {local ? (
        <button
          type="button"
          onClick={() => setLocal('')}
          className="flex-none text-[color:var(--text-muted)] hover:text-[color:var(--text-primary)] transition-colors"
          title="Clear"
        >
          <X size={12} />
        </button>
      ) : null}
    </div>
  );
}
